export default __webpack_public_path__ + "static/media/twitter.93567450.svg";